
// Auto-generated, edits will be overwritten
const spec = {
  'host': 'localhost',
  'schemes': [
    'http'
  ],
  'basePath': '/api/v1',
  'contentTypes': [
    'application/zrok.v1+json'
  ],
  'accepts': [
    'application/zrok.v1+json'
  ],
  'securityDefinitions': {
    'key': {
      'type': 'apiKey',
      'in': 'header',
      'name': 'x-token'
    }
  }
}
export default spec
